import { tailwindMerge } from '@inato/ui';
import type React from 'react';

export const MainLayoutContainer = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={tailwindMerge('flex min-h-screen flex-col', className)}>
      {children}
    </div>
  );
};
